// CSS:
// 1、公共部分
// 1、公共部分
import "../public/css/global.css";
import "../public/css/commonHead.css";
import "../public/css/messageDialogBox.css";
import "../public/css/dataEditModal.css";
// 20251028：signupAndLogin.ejs 页面不再做为单独访问页面管理
import "../public/css/signupAndLogin.css";
import "../public/css/commonFooter.css";
// 2、独有部分
import "../public/css/visitor.css";
import "../public/css/checkoutModal.css"
import "../public/css/scanToPay.css";;

// JS:
// 1、公共部分
import '../public/js/common/appVariables.js';  // 20260905 Add，要优先于 indexedDBManager.js
// 所有页面的公共部分，由单独的入口文件管理了
// 1.1、公共部分的静态资源部分，通过静态资源的方式导入第三方库
// 第三方静态资源，通用性，每个页面都要有。—— 做为静态资源注入页面进行管理，不打包！
// 1.2、所有页面的公共部分
// 20251119：只需在 commonHead 入口中包含即可，其它入口不需要再包含！-> 
// 20260420 取消 commonHead 入口，改为自己 SPA 页面自己管理
import '../public/js/common/pagesMessageBus.js';  // 这是基础设施，优先加载初始化！

import '../public/js/common/mountGlobalObjects.js';
import '../public/js/common/axiosInterceptor.js';  // 20260905 Add

import '../public/js/commonHead.js';
import '../public/js/messageDialogBox.js';
import '../public/js/common/clickFlame.js';
import '../public/js/dataEditModal.js'
import '../public/js/common/pagaDataLifeCycleManager.js'  // 20260420
import '../public/js/common/indexedDBManager.js';  // 20260420
// 20251028：signupAndLogin.ejs 页面不再做为单独入口页面管理
import '../public/js/signupAndLogin.js';
// 开发阶段不引用该脚本，正式上线时测试后引入
// import '../public/js/commonFooter.js';
// 2、独有部分，顺序很重要，有依赖关系
import '../public/js/checkoutModal.js';
import '../public/js/socialInteraction.js';
import '../public/js/visitor.js';
